// @flow
import * as React from 'react';

import { generateAutoMessageSftpCredentials } from 'admin/actions/AutoMessageSftpCredentialsActions';
import type { AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials } from 'admin/components/AdminAutoMessageSftpCredentials/queries/__generated__/AdminAutoMessageSftpCredentials';

type Props = {
  children: Function,
  orgUuid: string,
  onCredentialGeneration: (
    sftpCredentials: AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials
  ) => void,
};

type State = {
  credentials: ?{
    username: string,
    password: string,
  },
};

class AdminNewAutoMessageSftpCredentialsFormContainer extends React.Component<Props, State> {
  state = {
    credentials: undefined,
  };

  handleCredentialGeneration = (displayName: ?string) => {
    if (!displayName) {
      console.error(
        'AdminNewAutoMessageSftpCredentials - tried to generateSftpFeatureCredentials without a displayName'
      );
      return;
    }

    const { orgUuid } = this.props;
    generateAutoMessageSftpCredentials(displayName, orgUuid, sftpCredentials => {
      this.setState({
        credentials: sftpCredentials.credentials,
      });
      this.props.onCredentialGeneration(sftpCredentials);
    });
  };

  render() {
    const { credentials } = this.state;
    return this.props.children({
      credentials,
      onCredentialGeneration: this.handleCredentialGeneration,
    });
  }
}

export { AdminNewAutoMessageSftpCredentialsFormContainer };

export default AdminNewAutoMessageSftpCredentialsFormContainer;
